(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/game-promotion-poker-tournament/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/game-promotion-poker-tournament/assets/javascripts/render-component.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const isServer = typeof exports === 'object';
let trinidad;
if (isServer) {
  trinidad = require('@svenskaspelab/trinidad-core').core;
}
const getTournamentInformationServer = async (bannerItem, req) => {
  try {
    var _response$tournaments;
    const path = "/poker/2/tournaments/".concat(bannerItem.layoutConfig.tournamentType, "/upcoming");
    const response = await trinidad.jupiter.callAsync({
      method: 'GET',
      path: "".concat(path, "?count=1&gameType=").concat(bannerItem.layoutConfig.gameType),
      req
    });
    return (response === null || response === void 0 || (_response$tournaments = response.tournaments) === null || _response$tournaments === void 0 ? void 0 : _response$tournaments[0]) || {};
  } catch (err) {
    return {};
  }
};
const getTournamentInformationClient = async bannerItem => {
  try {
    var _response$tournaments2;
    const path = "/poker/2/tournaments/".concat(bannerItem.layoutConfig.tournamentType, "/upcoming");
    const {
      response
    } = await svs.core.jupiter.callAsync({
      method: 'GET',
      path: "".concat(path, "?count=1&gameType=").concat(bannerItem.layoutConfig.gameType)
    });
    return (response === null || response === void 0 || (_response$tournaments2 = response.tournaments) === null || _response$tournaments2 === void 0 ? void 0 : _response$tournaments2[0]) || {};
  } catch (err) {
    return {};
  }
};
const getSetup = async (bannerItem, req, res) => {
  var _trinidad$config$opti, _trinidad$components$;
  const hbsCompiled = isServer ? global.internalInstances.get('hbs').cache['components-banner_layouts-game_promotion_poker_tournament-item'] : svs.banner_layouts.game_promotion_poker_tournament.templates.item;
  const isAdmin = isServer ? req.userSession.hasRole(req.userSession.roles.INTERNAL) : svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
  const isDesktop = isServer ? req.capabilities.formFactor === 'desktop' : svs.core.detect.formfactor.desktop();
  const features = isServer ? res.locals.features : svs.core.data.features;
  const tournamentInformation = isServer ? await getTournamentInformationServer(bannerItem, req) : await getTournamentInformationClient(bannerItem);
  const exchangeRate = isServer ? (_trinidad$config$opti = trinidad.config.options) === null || _trinidad$config$opti === void 0 || (_trinidad$config$opti = _trinidad$config$opti.cms) === null || _trinidad$config$opti === void 0 ? void 0 : _trinidad$config$opti.exchangeRate : svs.game_promotion_poker_tournament.data.banner_layouts.exchangeRate;
  const formatCurrency = isServer ? (_trinidad$components$ = trinidad.components.require('utils', 'format').api) === null || _trinidad$components$ === void 0 ? void 0 : _trinidad$components$.Currency : svs.utils.format.Currency;
  const {
    formatDate
  } = isServer ? trinidad.components.require('lb-utils', 'helper-formatdate').api : svs.components.lbUtils.helpers.formatDate;
  const constants = isServer ? trinidad.components.require('poker', 'common').constants : svs.components.poker.common.constants;
  return {
    hbsCompiled,
    isAdmin,
    isDesktop,
    tournamentInformation,
    features,
    exchangeRate,
    formatDate,
    formatCurrency,
    constants
  };
};

async function renderComponent(bannerItem, widgetInfo, position, req, res) {
  const {
    hbsCompiled,
    isAdmin,
    isDesktop,
    features,
    tournamentInformation,
    exchangeRate,
    formatDate,
    formatCurrency,
    constants
  } = await getSetup(bannerItem, req, res);
  const trackingStringWithFixedStructure = [widgetInfo.widgetType, widgetInfo.trackingId || widgetInfo.widgetName, position, bannerItem.layoutType, bannerItem.title].join('/');
  bannerItem.images = bannerItem.images || [];
  let startDate = formatDate(tournamentInformation === null || tournamentInformation === void 0 ? void 0 : tournamentInformation.startTime, true, true, false);
  startDate = startDate.charAt(0).toUpperCase() + startDate.slice(1);
  const gameTypeText = constants.MapGameTypeText[tournamentInformation === null || tournamentInformation === void 0 ? void 0 : tournamentInformation.gameType];
  const title = gameTypeText && startDate ? "".concat(gameTypeText, " - ").concat(startDate) : null;
  let buyInText;
  if (tournamentInformation !== null && tournamentInformation !== void 0 && tournamentInformation.buyIn) {
    const isEuro = (tournamentInformation === null || tournamentInformation === void 0 ? void 0 : tournamentInformation.currency) === 'EUR';
    const euroConvertedBuyin = tournamentInformation.buyIn * exchangeRate;
    buyInText = "Ink\xF6p ca ".concat(formatCurrency(isEuro ? euroConvertedBuyin : tournamentInformation.buyIn), " kr");
  } else {
    buyInText = 'Spela Poker';
  }
  return hbsCompiled(_objectSpread(_objectSpread({}, bannerItem.layoutConfig), {}, {
    title,
    tournamentName: tournamentInformation === null || tournamentInformation === void 0 ? void 0 : tournamentInformation.name,
    registrationCountText: (tournamentInformation === null || tournamentInformation === void 0 ? void 0 : tournamentInformation.registrationCount) >= 0 ? "".concat(tournamentInformation.registrationCount, " anm\xE4lda") : '',
    tournamentId: tournamentInformation === null || tournamentInformation === void 0 ? void 0 : tournamentInformation.id,
    buyInText,
    isAdmin,
    bannerId: bannerItem.id,
    image: bannerItem.images.find(image => image.typeName === 'productImage'),
    trackingString: trackingStringWithFixedStructure,
    crm: bannerItem.targetOffer,
    features,
    isDesktop
  })) || '';
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  setGlobal('svs.banner_layouts.game_promotion_poker_tournament', {
    renderComponent
  });
}

 })(window);